import { render, staticRenderFns } from "./ComplaintFollowUpFilter.vue?vue&type=template&id=5cb5a4f4&"
import script from "./ComplaintFollowUpFilter.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports